<template>
  <q-btn class="badge-danger btn tw-document-trigger-btn" @click="toggleShowControls" floating>
    <q-badge color="red" floating>
    {{ alertList.length }}
  </q-badge>
    <img v-if="alertList.length> 0" src="@/assets/icons/red-alert-icon.svg"  alt="Gestion Alert" />
    <img v-else src="@/assets/icons/white-alert-icon.svg" style="width: 68px;
    margin-top: -22px;" alt="Gestion Alert" />
    <q-tooltip>{{ $t("order.tooltip.alert") }}</q-tooltip>
  </q-btn>
 <AlertDialog v-if="toggleShow"/>
</template>

<script lang="ts">
import store from "@/store";
import {Options, Vue} from "vue-class-component";
import AlertDialog from "./AlertDialog.vue";
import { useRoute } from "vue-router";
import { globalConfig } from "@/utils";



@Options({
  components: { AlertDialog }
})
export default class AlertButton extends Vue {

  toggleShowControls() {
    return store.dispatch('orderModule/toggleShow')
  }


  get toggleShow(){
  return store.state.orderModule.showAlert
}
get order() {
    if( this.currentRoute === 'TaskDetail'){
        return store.state.taskModule.order
    }
    else{
        return store.state.orderModule.order;
    }
  }
  get recoverState() {
     const orderState = localStorage.getItem(globalConfig.storageKeys.orderTask)
     const orderResourceUid = orderState ? JSON.parse(orderState).resourceUid : ""
    return orderResourceUid;
  }

  get currentRoute() {
    return useRoute().name;
  }
  
get alertList(){
  const rows = store.state.orderModule?.alertList || []
  const notDeletetdAlerts = rows 
                            ? rows.filter((alert:any) => alert && alert.alertValidity && alert.alertValidity.until === null)
                            : []
  return notDeletetdAlerts
}
created(){
  store.dispatch("orderModule/getOrderAlertList", {
      filter: {
        orderId: this.order && this.order.resourceUid ? this.order.resourceUid : this.recoverState,
      },
    });
  }
}
</script>

<style scoped></style>
